import { Block, LISBlock, Specimen } from "pwapi";

export type SortedBlock = Block & {
  full_name: string;
};

// DO NOT USE THIS FUNCTION
//
// _compareBlocks() is only exported for testing purposes
export const _compareBlocks = (a: Block, b: Block): number =>
  (a.name || "").localeCompare(b.name || "", "en", {
    numeric: true,
    sensitivity: "base",
  });

export const fullNameForBlock = (block: Block, specimen?: Specimen) => {
  return `${specimen?.name || ""}${block.name || ""}`;
};

const _mapBlockToSortedBlock = (
  block: Block,
  specimen?: Specimen
): SortedBlock => ({
  ...block,
  full_name: fullNameForBlock(block, specimen),
});

// DO NOT USE THIS FUNCTION DIRECTLY
//
// sortBlocks() is a pure function with no memoization or caching built in.
// Instead, use functions from selectors/selectSortedCaseDetail.ts or hooks/useSortedCase.
// It is preferable to use the selectors when possible.
export const sortBlocks = (
  blocks: Block[] = [],
  sortedSpecimens: Specimen[] = []
): SortedBlock[] => {
  const specimenIds = sortedSpecimens.map((s) => s.id);
  const orphanBlocks = blocks
    .filter((b) => !b.specimen_id || !specimenIds.includes(b.specimen_id))
    .sort(_compareBlocks)
    .map((b) => _mapBlockToSortedBlock(b));
  const specimenBlocks = sortedSpecimens
    .map((specimen) =>
      blocks
        .filter((block) => block.specimen_id === specimen.id)
        .sort(_compareBlocks)
        .map((block) => _mapBlockToSortedBlock(block, specimen))
    )
    .flat();

  return orphanBlocks.concat(specimenBlocks);
};

const pieceCountLabels = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "1F": "1 + F",
  "2F": "2 + F",
  "3F": "3 + F",
  "4F": "4 + F",
  "5F": "5 + F",
  F: "F",
};
export const pieceCountEnumToLabel = (
  pieceCount?: Block.piece_count | LISBlock.piece_count | null
) => {
  return (pieceCount && pieceCountLabels[pieceCount]) || pieceCount;
};
